import * as types from './types';
import { decodeFrom } from '~/utils/config';

const initialState = {
  isManualCustom: '',
  isVinOutline: false,
  vinManual: false,
  vehicleInfo: {},
  cages: {},
  vinstatus: '',
  openCam: decodeFrom.ORTHER,
  isDirectInput: false,
};

const vinReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case types.VIN_STATUS: {
      return {
        ...state,
        vinstatus: payload.status,
      };
    }
    case types.SHOW_VIN: {
      return {
        ...state,
        vinManual: true,
        openCam: payload.status,
        isDirectInput: payload.isDirect,
      };
    }
    case types.HIDE_VIN: {
      return {
        ...state,
        vinManual: false,
      };
    }
    case types.RESET_OUTLINE: {
      return {
        ...state,
        isVinOutline: payload.value,
      };
    }
    case types.SHOW_VEHICLE_INFO: {
      return {
        ...state,
        vehicleInfo: payload.info,
      };
    }
    case types.DETECT_OUTLINE_VEHICLE: {
      return {
        ...state,
        cages: payload.outlineData,
      };
    }
    case types.VIN_MANUAL_CAM: {
      return {
        ...state,
        isManualCustom: payload.type,
      };
    }

    case types.VIN_QR_SCANNER: {
      return {
        ...state,
        qrCodeScanner: payload.type,
      };
    }
    case types.SET_CAGES: {
      return {
        ...state,
        cages: payload.cages,
      };
    }
    case types.RESET_VEHICLE: {
      return initialState;
    }
    default:
      return state;
  }
};
export default vinReducer;
